import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=e144c564&scoped=true"
import script from "./Links.vue?vue&type=script&lang=js"
export * from "./Links.vue?vue&type=script&lang=js"
import style0 from "./Links.vue?vue&type=style&index=0&id=e144c564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e144c564",
  null
  
)

export default component.exports